/**
 * Asset model module
 *
 * @author MattJS (matt@yext.com)
 */
goog.provide('yext.dam.asset');
goog.provide('yext.dam.asset.Asset');

yext.dam.asset.assets = [];
yext.dam.asset.UID = 1;
yext.dam.asset.assetMap = {};

/**
 * @constructor
 * @param {!Object} data Details about the asset
 */
yext.dam.asset.Asset = function(data) {
  this.UID = yext.dam.asset.UID++;

  this.description = '';
  this.labels = [];

  $.extend(true, this, data);
};

/**
 * Create a photo asset model
 *
 * @param {!Object} data yext.dam.asset.Asset details used to build the model
 * @return {yext.dam.asset.Asset} Photo asset model
 */
yext.dam.asset.create = function(data) {
  // Type safety
  if (typeof data != 'object') {
    return;
  }

  var asset = new yext.dam.asset.Asset(data);
  yext.dam.asset.assets.push(asset);
  yext.dam.asset.assetMap[asset.UID] = asset;
  return asset;
};

/**
 * Get a photo asset by UID
 *
 * @param {number} UID Unique id to search by
 * @return {yext.dam.asset.Asset} Photo asset model
 */
yext.dam.asset.get = function(UID) {
  return yext.dam.asset.assetMap[UID];
};

/**
 * Get all yext.dam.asset.assets
 *
 * @return {!Array.<yext.dam.asset.Asset>} List of all the photo yext.dam.asset.assets
 */
yext.dam.asset.getAll = function() {
  return yext.dam.asset.assets;
};

/**
 * Remove an asset by UID
 *
 * @param {number} UID Unique id for asset to be removed
 */
yext.dam.asset.destroy = function(UID) {
  var asset = yext.dam.asset.assetMap[UID];

  if (asset) {
    var index = yext.dam.asset.assets.indexOf(asset);
    yext.dam.asset.assets.splice(index, 1);
    delete yext.dam.asset.assetMap[UID];
  }
};

/**
 * Destroy all yext.dam.asset.assets
 */
yext.dam.asset.destroyAll = function() {
  yext.dam.asset.assets = [];
  yext.dam.asset.assetMap = {};
};
